import React from "react";
import { toast } from "react-toastify";
import LoaderIcon from "../../../assets/LoaderIcons/Loader.gif";

const width = window.innerWidth;

const paragraphStyle = {
  width: "100%",
  height: "19px",
  textAlign: "left",
  font: "normal normal normal 14px/19px Open Sans",
  letterSpacing: "0px",
  color: "#FFFFFF",
  opacity: 1,
};
const divStyle = {
  display: "flex",
  justifyContent: width < 480 ? "left" : "center",
  alignItems: "center",
};
const imageStyle = {
  width: "50px",
  height: "40px",
  opacity: 1,
  paddingRight: "10px",
};
const RefreshBalanceToast = () => {
  return toast(
    <div style={divStyle}>
      <img src={LoaderIcon} alt="LoaderIcon" style={imageStyle} />
      <p style={paragraphStyle}>Refreshing balance</p>
    </div>,
    {
      position: "bottom-right",
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      fontSize: "20px",
      style: {
        width: "100%",
        height: "50px",
        borderRadius: "10px",
        backgroundColor: "#AE9041",
        color: "#fff",
        zIndex: "9999999",
      },
    }
  );
};

export default RefreshBalanceToast;
